// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDBrP-3-v0Fjrvm330wg6vbOgNkDW8pv3w",
    authDomain: "maktabti-cef13.firebaseapp.com",
    databaseURL: "https://maktabti-cef13.firebaseio.com",
    projectId: "maktabti-cef13",
    storageBucket: "maktabti-cef13.appspot.com",
    messagingSenderId: "648076082641",
    appId: "1:648076082641:web:8d1e72a276e093626134f0",
    measurementId: "G-6HQ1C0W3XT"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
